import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lux_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.msg || JSON.stringify(d)).replace(/^Value error, /, "")).join(" ");
  return detail.msg || String(detail);
}

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const STATUS_LABEL = {
  awaiting_payment: "Awaiting payment",
  awaiting_zelle: "Waiting for Zelle payment",
  zelle_refund_due: "Zelle refund due",
  not_charged: "Not charged",
  searching: "Searching",
  accepted: "Accepted",
  arrived: "Arrived",
  in_progress: "In progress",
  completed: "Completed",
  cancelled: "Cancelled",
};
